<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row embed">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3 card-ttl">埋め込みコード</h4>
						<div class="loading"  v-show="loading">受信中...</div>

						<div>

							<div class="form-group site-selection-area">
                              <label >対象サイト</label>
                              <div class="input-group" id="group1">
									<span class="selected-option">{{ selectedSiteData.site_name_jp }}</span>
									<span class="selected-option">{{ selectedSiteData.site_domain }}</span>
                              </div>
							  <span class="stp">コードの対象サイトを変更する場合は、メニュー左上よりサイト変更を行なってください。</span>
                            </div>

							<div class="pwa-selection">
							<div class="form-group">
                              <div class="subttl"><span>PWA（Progressive Web Apps）対応状況</span>
							
                                <ul class="radio-container">
                                  <li>
                                    <base-radio name="no-pwa"  v-model="radio"  :inline="true">
                                    未対応
                                    </base-radio>
                                  </li>                             
                                  <li>
                                    <base-radio name="pwa" v-model="radio" :inline="true">
									対応済み
                                    </base-radio>
                                  </li>
                                </ul>
							</div>
                              </div>
							  <div class="help"><span class="sup">※iOS/iPadOSはPWAのAdd to Homescreen対応が必要です。弊社でのサポートも可能です。お問い合わせは</span><a href="/contact" target="_blank">こちら</a></div>
							  </div>
							 
							  <div v-show="radio=='no-pwa'">
								<span class="stp">1．以下の2つのコードをコピーして、Web サイトの各ページに貼り付けてください。</span>
								<span class="stp">① ページの &lt/head&gt タグの前に貼り付けます。</span>
							  </div>

							  <div v-show="radio=='pwa'">
								<span class="stp">1．以下のコードをコピーして、Web サイトの各ページの &lt/head&gt タグの前に貼り付けてください。</span>
							  </div>
							  
                              <div class="input-group" id="group2">
								<textarea class="visuallyhidden txt1" id="siteTag" disabled>{{ selectedSiteData.site_tag }}</textarea>

								<div class="button-tooltip-container">
    								<button  @click="copyToClipboard('siteTag')" class=copybutton>
										<img src="/img/icons/copy.svg" alt="Copy"/>
                                    <!--
									<svg width="22" height="22" viewBox="0 0 20 20" version="1.1"><path fill="#000" d="M20,18.2V19H0v-1.5h16.4h2.1V5.2H20V18.2z M1.5,11.3V5.2H0v12.3h1.5V11.3z M9.2,12.8V0.5h1.5v12.3H9.2z M4.6,5.2h1.5v1.5H4.6V5.2z M6.2,3.6h1.5v1.5H6.2V3.6z M13.8,5.2h1.5v1.5h-1.5V5.2z M12.3,3.6h1.5v1.5h-1.5V3.6z M10.8,2.1h1.5v1.5h-1.5V2.1zM7.7,2.1h1.5v1.5H7.7V2.1z"></path></svg>
									-->
								</button>
								<span id="custom-tooltip-siteTag" class="custom-tooltip">copied!</span>
								</div>

                                
                              </div>
                              <div v-show="radio=='no-pwa'">
								<div>
								<span class="stp">② ページの &lt/body&gt タグの前に貼り付けます。</span>
							  </div>
								<div class="input-group" id="group3">
									<textarea class="visuallyhidden txt2" id="sw" disabled>
<!-- Service worker installation-->
<script>
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js', {scope: '/'})
          .then(registration => {
            //console.log(`Service Worker registered! Scope: ${registration.scope}`);
          })
          .catch(err => {
            console.log(`Service Worker registration failed: ${err}`);
          });
      });
    }
  </script>
									</textarea>

									<div class="button-tooltip-container">
										<button  @click="copyToClipboard('sw')" class=copybutton>
											<img src="/img/icons/copy.svg" alt="Copy"/>
									    </button>
									<span id="custom-tooltip-sw"  class="custom-tooltip">copied!</span>
									</div>
								</div>
								
								<div class="d-wrap">
								<span class="stp">2． </span><button @click="download" type="button" class="btn-download">sw.jsファイルをダウンロード</button><span class="stp">し、サーバーのDocumentRoot ディレクトリへアップしてください。</span>
								</div>
							  </div>

							  <div  v-show="radio=='pwa'">
								<div>
								<span class="stp">2．以下のコードをコピーして、Service Workerに追記してください。</span>
							  </div>
								<div class="input-group" id="group3">
									<textarea class="visuallyhidden txt3" id="sw2" disabled> 
//push L service worker インポート
self.importScripts("{{swUrl}}");
</textarea>

									<div class="button-tooltip-container">
										<button  @click="copyToClipboard('sw2')" class=copybutton>
											<img src="/img/icons/copy.svg" alt="Copy"/>
									    </button>
									<span id="custom-tooltip-sw2"  class="custom-tooltip">copied!</span>
									</div>
								</div>
							  </div>
                            </div>
							
						</div>
					</div>
                </div>
            </div>

		</div>
</template>

<script>

export default {
	components: { },
	props: ['siteData'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			siteId:null,
			siteList:{},
			radio:"no-pwa",
			selectedSiteData:{},
			swUrl: ""
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;	
		//console.log(this.siteData)
		this.selectedSiteData = JSON.parse(this.siteData);
		if(window.location.origin == "https://pushl.info") {
			this.swUrl = "https://cdn.pushl.info/sws/pushl-sw.js"
		}
		if(window.location.origin == "https://dev.pushl.info") {
			this.swUrl = window.location.origin + "/enduser/sws/pushl-sw_dev.js"
		}
		if(window.location.origin == "https://stg.pushl.info") {
			this.swUrl = window.location.origin + "/enduser/sws/pushl-sw_stg.js"
		}
	},

	methods: {
		setStatus(response) {
      	this.siteList = response.data.sitelist;
    	},
		copyToClipboard(copyTarget) {
			
			let clipboardText = document.getElementById(copyTarget);
            
			// Select the text field
			//clipboardText.select();
			//clipboardText.setSelectionRange(0, 99999); // For mobile devices

			if(navigator.clipboard == undefined) {
				window.clipboardData.setData('text/html', clipboardText.value);
			} else {
				navigator.clipboard.writeText(clipboardText.value);
			}


			document.getElementById("custom-tooltip-" + copyTarget).style.display = "inline";
			setTimeout( function() {
				document.getElementById("custom-tooltip-" + copyTarget).style.display = "none";
			}, 1000);

		},

		download() {
			
						// Content of the JavaScript file
			const jsContent = '\
/*\
service worker setting relating to host site goes here\
*/\
\n\
//push L service worker インポート\
\n\
self.importScripts("' + this.swUrl + '");\
';

			// Create a Blob object
			const blob = new Blob([jsContent], { type: 'text/javascript' });

			// Create a URL for the Blob object
			const url = URL.createObjectURL(blob);

			// Create an anchor element
			let link = document.createElement('a');

			// Set the attributes for the anchor element
			link.download = 'sw.js';
			link.href = url;

			// Simulate a click on the anchor element to trigger the download
			link.click();

			// Clean up by revoking the URL object
			URL.revokeObjectURL(url);

    	
		}
	}

}
</script>

<style scoped>
.selected-option {
	margin-right: 20px;
	min-width:148px;
}
.pwa-selection {
	display:flex;
}
.pwa-selection .form-group {
	width: 310px;
	min-width: 310px;
}
.help {
	text-indent: -22px;
	padding-left: 22px;
}
.copybutton {
	background-color:transparent;
	border:0;
	outline:0;
	cursor:pointer;
	opacity:1;
	position:absolute;
	top: 30px;
	right:30px;
	z-index:9;
	border-radius:24px;
}
.button-tooltip-container {
    display: flex;
    align-items: center;
    margin-top: 16px;
    min-height: 30px;
}

.custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
	background-color: rgba(94,118,228, .9);
    border-radius: 4px;
    color: #fff;
	position:absolute;
	right:10px;
	top: -40px;
}

textarea {
	width: 100%;
	height: 400px;
	resize: none;
	border:1px solid #CDD3D9;
	font-size:12px;
	padding: 15px;
}

.txt2,.txt3 {
	height: 290px;
}
.stp {
	display:block;
	margin: 10px auto;
}

.form-group {
	max-width: 1024px;
	position: relative;
}

.card-body {
	padding: 3.6rem;
	font-size: .9rem;
}
.radio-container {
	margin: 1rem auto -.8rem;
}
.radio-container li {
	width: 148px;
}
#group2 {
	margin: 0 auto 25px;
}
.sup {
	font-size:11px;
	margin-left:.7rem
}
.help a {
	font-size: 11px;
	text-decoration: underline;
	word-break: keep-all;
}
.subttl > span:first-child {
	font-weight: 700;
}

.btn-download {
    background: transparent;
    border: none;
    text-decoration: underline;
    color: #5e72e4;
}
.d-wrap .stp {
	display: initial;
}

.d-wrap {
	margin-top: 10px;
}
</style>